import CustomMetricsPanel from "../../components/CustomMetricsPanel";
import { useAuth } from "../../context/AuthContext";

/**
 * ClientAssessment — client-side view of performance-test benchmarks.
 * Iter 60.2 — split from Metrics to keep body composition and performance tests visually separate.
 */
export default function ClientAssessment() {
  const { user } = useAuth();
  if (!user) return null;
  return (
    <div className="space-y-8" data-testid="client-assessment-page">
      <div>
        <div className="tracker text-brand mb-3">[ Performance tests ]</div>
        <h1 className="font-display text-4xl sm:text-5xl">Assessment.</h1>
        <p className="text-zinc-500 mt-2">Track your bike time, dead hang, broad jump, sprints and any other benchmarks your coach has set up.</p>
      </div>
      <CustomMetricsPanel clientId={user.id} canEditTemplates={false} />
    </div>
  );
}
